import { render, staticRenderFns } from "./ClerkInput.vue?vue&type=template&id=847e8906&scoped=true&"
import script from "./ClerkInput.vue?vue&type=script&lang=js&"
export * from "./ClerkInput.vue?vue&type=script&lang=js&"
import style0 from "./ClerkInput.vue?vue&type=style&index=0&id=847e8906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "847e8906",
  null
  
)

/* custom blocks */
import block0 from "./ClerkInput.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports